// extracted by mini-css-extract-plugin
export var body = "_bv-0";
export var sectionHeader = "_bv-4";
export var shortcutColumns = "_bv-2";
export var shortcutList = "_bv-1";
export var shortcutSection = "_bv-3";